import { render, staticRenderFns } from "./ReceiptsTabs.vue?vue&type=template&id=a24f8c3e&scoped=true"
import script from "./ReceiptsTabs.vue?vue&type=script&lang=js"
export * from "./ReceiptsTabs.vue?vue&type=script&lang=js"
import style0 from "./ReceiptsTabs.vue?vue&type=style&index=0&id=a24f8c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a24f8c3e",
  null
  
)

export default component.exports